// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"315":"a345f98e","367":"e315f8fe"}[chunkId] + ".css";
};